
import util,{_} from '@/libs/util'
import common from '@/libs/common.mixin'
import FileItem from 'c%/FileItem.vue'
import Group from 'vux/src/components/group/index.vue'


export default{
mixins: [ common ],
components: {
Group,
FileItem
},
data () {
return {
id: this.$route.params.id,
info: {}
}
},
mounted () {
this.init_data()
},
computed: {
logo () {
let ui = window.CLIENT_PARAMS,
result = '/static/img/logo-2.jpg'
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.logo!=''){
result = ui.mobile.logo
}
return result
},
sysName () {
let result = '校360学习管家',
ui = window.CLIENT_PARAMS
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.system_name!=''){
result = ui.mobile.system_name
}
return result
}
},
methods: {
init_data () {
let uri = util.sprintf('open/file_package?short_id=%s&with=file_package_file,employee',this.id)
this.$rest(uri).get()
.success(data=>{
this.info = data
}).error(response=>{
this.toast(response.body.message||'获取文件包失败~','warn')
})
}
}
}



// WEBPACK FOOTER //
// ./src/views/public/filepackage.vue